'use strict';

// Webphone modal window class
function WebphoneModalWindow(params) {

    if (typeof params === 'object') {

        if (typeof params.logger === 'object')
            this.l = params.logger;
        else
            this.l = WebphoneLogger.factory();

    } else {
        this.l = WebphoneLogger.factory();
    }

    this.current = null;
    this.onCancel = null;
    this.onClose = null;
    this.locked = false;
    this.topSelector = '.webphone';
    this.bgSelector = '.window-modal-bg';
    this.timeoutAutoClose = null;
};

WebphoneModalWindow.prototype.clear = function() {

    this.current = null;
    this.onCancel = null;
    this.onClose = null;
    this.locked = false;

    jQuery(this.topSelector + ' .close').off();
    jQuery(this.topSelector + ' ' + this.bgSelector).off();
    jQuery(this.topSelector + ' .window-modal').off();
    jQuery(document).off('keyup',null,this.evtEscape);
};

WebphoneModalWindow.prototype.open = function(code, params) {
    this.debug('open', 'called. code= ' + code + ', this.current= ' + this.current);

    var _this = this;

    if (this.locked
        && this.current !== null) {
        this.debug('open', 'is already opened and locked, do nothing');
        return;
    }

    if (this.current !== null) {
        if (this.current !== code) {
            jQuery(this.topSelector + ' .window-modal.window-'+this.current).hide();
            jQuery(this.topSelector + ' .window-modal.window-'+code).show();
        }
    } else {
        jQuery(this.topSelector + ' ' + this.bgSelector).show();
        jQuery(this.topSelector + ' .window-modal.window-'+code).show();
    }

    this.clear();
    this.current = code;

    if (typeof params !== 'object')
        params = {};

    if (typeof params.closeBtn !== 'undefined'
        && params.closeBtn) {
        jQuery(this.topSelector + ' .close').click(this.evtCancel.bind(this, 'close btn'));
    } else {
        jQuery(this.topSelector + ' .close').off();
    }

    if (typeof params.closeBg !== 'undefined'
        && params.closeBg) {
        setTimeout(function() {
            jQuery(this.topSelector + ' ' + this.bgSelector).click(_this.evtCancel.bind(_this, 'bg'));
        }, 1000);
    } else {
        jQuery(this.topSelector + ' ' + this.bgSelector).off();
    }

    if (typeof params.closeEsc !== 'undefined'
        && params.closeEsc) {
        jQuery(document).on('keyup', null, this, this.evtEscape);
    } else {
        jQuery(document).off('keyup', null, this.evtEscape);
    }

    if (typeof params.closeBody !== 'undefined'
        && params.closeBody) {
        jQuery(this.topSelector + ' .window-modal').click(this.evtCancel.bind(this, 'body'));
    } else {
        jQuery(this.topSelector + ' .window-modal').off();
    }

    if (typeof params.onClose === 'function') {
        this.onClose = params.onClose;
    }

    if (typeof params.onCancel === 'function') {
        this.onCancel = params.onCancel;
    }

    if (typeof params.lock !== 'undefined') {
        this.locked = params.lock ? true : false;

        this.debug('open', 'locked= ' + this.locked);
    }

    if (this.timeoutAutoClose !== null) {
        clearTimeout(this.timeoutAutoClose);
        this.timeoutAutoClose = null;
    }

    if (typeof params.autoClose === 'number') {
        this.timeoutAutoClose = setTimeout(function() {

            if (_this.onCancel) {
                _this.debug('open', 'call onCancel()');
                _this.onCancel();
            }
            
            _this.close('auto ' + params.autoClose);
            
        }, params.autoClose);
    }

    return false;
};

WebphoneModalWindow.prototype.isOpenedAndLocked = function() {
    return this.locked
        && this.current !== null;
};

WebphoneModalWindow.prototype.close = function(place, force) {
    this.debug('close', 'called. this.current= ' + this.current + (typeof place !== 'undefined' ? (' place= ' + place) : ''));

    if (typeof force === 'undefined')
        force = false;

    var _this = this;

    return new Promise(function(resolve, reject) {
        if (_this.locked) {
            if (!force) {
                _this.debug('close', 'window is locked and force==false, do nothing');
                resolve();
            } else {
                _this.debug('close', 'window is locked and force==true !');
            }
        }

        if (_this.current !== null) {
            var code = _this.current;

            if ( jQuery(_this.topSelector + ' .window-modal.window-'+code).is(':visible') ) {
                jQuery(_this.topSelector + ' .window-modal.window-'+code).hide();
                jQuery(_this.topSelector + ' ' + _this.bgSelector).hide();
            }

            jQuery(_this.topSelector + ' .close').off();
            jQuery(_this.topSelector + ' ' + _this.bgSelector).off();
            jQuery(_this.topSelector + ' .window-modal').off();
            jQuery(document).off('keyup', null, _this.evtEscape);

            if (_this.timeoutAutoClose !== null) {
                clearTimeout(_this.timeoutAutoClose);
                _this.timeoutAutoClose = null;
            }

            if (_this.onClose) {
                _this.debug('close', 'call onClose()');
                _this.onClose();
            }

            _this.clear();
        } else {
            _this.debug('close', 'current == null, do nothing');
        }

        resolve();
    });
};

WebphoneModalWindow.prototype.evtEscape = function(evt) {
    if ( evt.which == 27 ) {
        evt.preventDefault();

        var _this = evt.data;

        if (_this.onCancel) {
            _this.debug('evtEscape', 'call onCancel()');
            _this.onCancel();
        }

        _this.close('escape key', true);
        
        jQuery(document).off('keyup',null,_this.evtEscape);
        return false;
    }
};

WebphoneModalWindow.prototype.evtCancel = function(place, evt) {
    this.debug('evtCancel', 'called');

    evt.preventDefault();

    if (this.onCancel) {
        this.debug('evtCancel', 'call onCancel()');
        this.onCancel();
    }

    this.close(place, true);

    return false;
};



WebphoneLogger.addLoggerMethods(WebphoneModalWindow, 'WebphoneModalWindow');
